export const DEBUG_KEEPER_URL_COOKIE = 'DEBUG_KEEPER_URL_COOKIE';
export const DEBUG_KEEPER_HEADERS_COOKIE = 'DEBUG_KEEPER_HEADERS_COOKIE';
